import { Component } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  templateUrl: './checkbox.component.html',
  styleUrls: [],
  imports: [ReactiveFormsModule, MatCheckbox],
})
export class CheckboxComponent {
  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;
}
